import { render } from "./DeliveryIconComponent.vue?vue&type=template&id=4731f75c&scoped=true"
import script from "./DeliveryIconComponent.vue?vue&type=script&lang=js"
export * from "./DeliveryIconComponent.vue?vue&type=script&lang=js"

import "./DeliveryIconComponent.vue?vue&type=style&index=0&id=4731f75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4731f75c"]])

export default __exports__